import React from 'react';
import { KnovioPageType } from '../../../lib/api/custom-page.types';
import { EmbedContainer } from '../../../lib/kv-embed';
import { arePageFlagsPending, useEventSettings } from '../../../lib/context-providers/event-settings-context/event-settings-context';


export const KnovioCustomPage: React.FunctionComponent<KnovioPageType> = (props: KnovioPageType): JSX.Element | null => {
  const eventSettings = useEventSettings();
  if (arePageFlagsPending(eventSettings)) return null;

  if (props && props.embedCodeId) return <EmbedContainer.Knovio embedId={props.embedCodeId} />;

  return null;
};
